// Judge.me: erst nach dem Laden scrollen, nicht in die eingeklappte Liste.
(function () {
  const previousScroll = window.judgemeOpts?.scrollTo || window.jdgmSettings?.scrollTo;
  let pending;

  function scrollToReviews(target, offset) {
    const list = target?.[0];
    if (!list?.matches('.jdgm-rev-widg__body, .jdgm-all-reviews__body, .jdgm-shop-reviews__body')) {
      return previousScroll?.(target, offset);
    }

    if (pending?.list === list) {
      pending.schedule();
      return false;
    }
    pending?.cleanup();
    const widget = list.closest('.jdgm-review-widget, .jdgm-all-reviews-widget');
    if (!widget) return false;

    const minHeight = widget.style.minHeight;
    widget.style.minHeight = `${widget.getBoundingClientRect().height}px`;
    let frame;
    let timer;
    let cancelled = false;
    const observer = new MutationObserver(schedule);

    function cancelScrolling() {
      cancelled = true;
    }

    function cleanup() {
      observer.disconnect();
      cancelAnimationFrame(frame);
      clearTimeout(timer);
      widget.style.minHeight = minHeight;
      for (const type of ['wheel', 'touchstart', 'pointerdown', 'keydown']) {
        window.removeEventListener(type, cancelScrolling, true);
      }
      pending = undefined;
    }

    function schedule() {
      cancelAnimationFrame(frame);
      frame = requestAnimationFrame(() => {
        if (!list.isConnected) return cleanup();
        if (!list.getClientRects().length || list.style.height || getComputedStyle(list).display === 'none') return;
        cleanup();
        if (cancelled) return;
        const headerHeight = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-height')) || 0;
        window.scrollTo({
          top: Math.max(0, list.getBoundingClientRect().top + window.scrollY - Math.max(headerHeight, offset || 0)),
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
        });
      });
    }

    pending = { list, cleanup, schedule };
    for (const type of ['wheel', 'touchstart', 'pointerdown', 'keydown']) {
      window.addEventListener(type, cancelScrolling, { capture: true, passive: true });
    }
    observer.observe(list, { attributes: true, attributeFilter: ['style', 'class'], childList: true });
    timer = setTimeout(cleanup, 15000);
    schedule();
    return false;
  }

  window.judgemeOpts = { ...window.judgemeOpts, scrollTo: scrollToReviews };
  if (window.jdgmSettings) window.jdgmSettings.scrollTo = scrollToReviews;
})();

 // Judge.me Datum-Format korrigieren auf pdp
(function(){
  function formatDateInNode(node){
    if(!node)return;
    var text=node.textContent;
    if(!text||text.indexOf('/')===-1)return;
    var newText=text.replace(/(\d{1,2})\/(\d{1,2})\/(\d{4})/g,function(_,d,m,y){
      var day=d.length===1?'0'+d:d;
      var month=m.length===1?'0'+m:m;
      return day+'.'+month+'.'+y;
    });
    if(newText!==text){node.textContent=newText;}
  }

  function updateAllDates(root){
    var context=root||document;
    var selectors=[
      '.jdgm-rev__timestamp',
      '.jdgm-carousel__item__timestamp',
      '.jdgm-carousel-item__timestamp'
    ];
    for(var i=0;i<selectors.length;i++){
      var nodes=context.querySelectorAll(selectors[i]);
      for(var j=0;j<nodes.length;j++){
        formatDateInNode(nodes[j]);
      }
    }
  }

  document.addEventListener('DOMContentLoaded',function(){
    updateAllDates();

    var observer=new MutationObserver(function(mutations){
      for(var i=0;i<mutations.length;i++){
        var mutation=mutations[i];
        if(mutation.type==='childList'&&mutation.addedNodes.length>0){
          for(var k=0;k<mutation.addedNodes.length;k++){
            var node=mutation.addedNodes[k];

            // Fall 1: Textknoten (wie im Homepage-Carousel)
            if(node.nodeType===3){
              var p=node.parentNode;
              if(p&&p.matches&&p.matches('.jdgm-rev__timestamp, .jdgm-carousel__item__timestamp, .jdgm-carousel-item__timestamp')){
                formatDateInNode(p);
              }
              continue;
            }

            // Fall 2: neue Elemente
            if(!(node instanceof HTMLElement))continue;
            if(node.matches&&node.matches('.jdgm-rev__timestamp, .jdgm-carousel__item__timestamp, .jdgm-carousel-item__timestamp')){
              formatDateInNode(node);
            }
            updateAllDates(node);
          }
        }
      }
    });

    observer.observe(document.body,{childList:true,subtree:true});
  });
})();
// END Judge.me Datum-Format korrigieren

//Sortierfolge von Filter umkehren
(function () {
  // IDs des Modell-Filter-Containers (Desktop + Mobile)
  const MODELL_FILTER_IDS = [
    'Details-filter.p.m.custom.modell_filter-template--26349241499912__product-grid',
    'MobDetails-filter.p.m.custom.modell_filter-template--26349241499912__product-grid'
  ];

  /**
   * Kehrt die Reihenfolge der Filter-Einträge um und weist
   * show-more-item/hidden-Klassen korrekt neu zu.
   */
  function reorderModellFilter(container) {
    if (!container) return;
    const ul = container.querySelector('ul');
    if (!ul) return;

    const lis = Array.from(ul.querySelectorAll(':scope > li'));
    if (lis.length === 0) return;

    // Anzahl der initial sichtbaren Einträge merken
    const visibleCount = lis.filter(
      (li) => !li.classList.contains('show-more-item')
    ).length;

    // Reihenfolge umkehren (neueste zuerst)
    lis.slice().reverse().forEach((li) => ul.appendChild(li));

    // show-more-item / hidden Klassen neu zuweisen
    Array.from(ul.querySelectorAll(':scope > li')).forEach((li, i) => {
      if (i < visibleCount) {
        li.classList.remove('show-more-item', 'hidden');
      } else {
        li.classList.add('show-more-item', 'hidden');
      }
    });
  }

  /**
   * Führt die Umsortierung in einem geparsten HTML-Dokument durch
   * (wird für den Patch des AJAX-Renders verwendet).
   */
  function reorderInDoc(doc) {
    MODELL_FILTER_IDS.forEach((id) => {
      // Punkte und Slashes in der ID escapen für querySelector
      const selector = '#' + id.replace(/\./g, '\\.').replace(/\//g, '\\/');
      const container = doc.querySelector(selector);
      if (container) reorderModellFilter(container);
    });
  }

  // ── 1. Initiale Umsortierung beim Seitenload ─────────────────────────────
  MODELL_FILTER_IDS.forEach((id) => {
    const selector = '#' + id.replace(/\./g, '\\.').replace(/\//g, '\\/');
    const container = document.querySelector(selector);
    if (container) reorderModellFilter(container);
  });

  // ── 2. Patch von FacetFiltersForm.renderFilters (AJAX-Updates) ───────────
  // Das Theme übergibt den HTML-String oder das bereits geparste Dokument,
  // wenn ein Filter aktiviert/deaktiviert wird.
  // Wir ordnen im HTML-String um, BEVOR er in den DOM geschrieben wird
  // → kein Flackern, kein Reset.
  const waitForFacetClass = setInterval(() => {
    const FacetClass = customElements.get('facet-filters-form');
    if (!FacetClass || FacetClass._modellFilterPatched) return;

    clearInterval(waitForFacetClass);

    const _orig = FacetClass.renderFilters;
    FacetClass.renderFilters = function (html, event) {
      // Revendo INP: das Theme uebergibt das bereits geparste Dokument - direkt
      // darin umsortieren, kein zweiter Parse und keine Serialisierung.
      if (html && typeof html.querySelector === 'function') reorderInDoc(html);
      // Legacy-Pfad: nur noch fuer Apps, die renderFilters mit rohem HTML rufen.
      // Teuer (Parse + outerHTML), deshalb hinter der Dokument-Variante.
      if (typeof html === 'string' && html.includes('modell_filter')) {
        try {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');
          reorderInDoc(doc);
          html = doc.documentElement.outerHTML;
        } catch (e) {
          console.warn('[Modell Filter] Reorder error:', e);
        }
      }
      return _orig.call(this, html, event);
    };

    FacetClass._modellFilterPatched = true;
  }, 100);
})();
//ende sortierfolge umkehren 

// Sticky CTA: Ein-/Ausblenden nach Scroll & Tidio-Widget-Steuerung
(function () {
  document.addEventListener('DOMContentLoaded', function () {

    var stickyCta = document.querySelector('.sticky-cta');
    if (!stickyCta) return;

    var buyButton = document.querySelector('.product-form__buttons, [name="add"]');
    var stickyBtn = stickyCta.querySelector('.sticky-cta__custom-button');
    var mobileBreakpoint = 768;

    function isMobile() {
      return window.innerWidth <= mobileBreakpoint;
    }

    function pulseButton() {
      if (!stickyBtn) return;
      if (stickyCta.classList.contains('sticky-cta--force-hide')) return;

      // Direkt per inline-style setzen — schlägt garantiert jede CSS-Spezifität
      stickyBtn.style.animation = 'none';
      void stickyBtn.offsetWidth; // Reflow erzwingen
      stickyBtn.style.animation = 'stickyPulse 1.2s ease-in-out';

      setTimeout(function () {
        stickyBtn.style.animation = '';
      }, 1300);
    }

    setInterval(pulseButton, 6000);

    function hideTidio() {
      // Offener Chat hat Vorrang; nach dem Schliessen holt revendo:chat-closed das nach.
      if (document.body.classList.contains('rv-chat-open')) return;
      if (window.tidioChatApi) {
        window.tidioChatApi.hide();
      } else {
        document.addEventListener('tidioChat-ready', function () {
          window.tidioChatApi.hide();
        }, { once: true });
      }
    }

    function showTidio() {
      if (window.tidioChatApi) window.tidioChatApi.show();
    }

    function showSticky() {
      var wasHidden = stickyCta.classList.contains('sticky-cta--force-hide');
      stickyCta.classList.remove('sticky-cta--force-hide');
      hideTidio();
      if (wasHidden) {
        setTimeout(pulseButton, 500);
      }
    }

    function hideSticky() {
      stickyCta.classList.add('sticky-cta--force-hide');
      showTidio();
    }

    if (isMobile()) {
      showSticky();
    } else {
      hideSticky();
    }

    document.addEventListener('revendo:chat-closed', function () {
      if (!stickyCta.classList.contains('sticky-cta--force-hide')) hideTidio();
    });

    function getVisibleViewportTop() {
      var header = document.querySelector('sticky-header');
      if (header) {
        return Math.max(0, header.getBoundingClientRect().bottom);
      }

      var rootStyles = getComputedStyle(document.documentElement);
      var cssHeight = parseFloat(rootStyles.getPropertyValue('--header-height-live'))
        || parseFloat(rootStyles.getPropertyValue('--header-height'));

      return cssHeight || 0;
    }

    function isBuyButtonVisible(element) {
      if (!element) return false;

      var rect = element.getBoundingClientRect();
      var topBound = getVisibleViewportTop();
      var viewportHeight = window.innerHeight;

      return rect.bottom > topBound && rect.top < viewportHeight;
    }

    function updateStickyVisibility(entryOrElement) {
      if (isMobile()) {
        showSticky();
        return;
      }

      // Desktop: Sticky sobald der Warenkorb-Button nicht mehr sichtbar ist
      // (inkl. Verdeckung durch sticky Header oben oder unterhalb des Viewports).
      var isVisible = typeof entryOrElement.isIntersecting === 'boolean'
        ? entryOrElement.isIntersecting
        : isBuyButtonVisible(entryOrElement);

      if (isVisible) {
        hideSticky();
      } else {
        showSticky();
      }
    }

    var buyButtonObserver;

    function setupBuyButtonObserver() {
      if (!buyButton || !('IntersectionObserver' in window)) return;

      if (buyButtonObserver) buyButtonObserver.disconnect();

      var topOffset = getVisibleViewportTop();
      buyButtonObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          updateStickyVisibility(entry);
        });
      }, {
        threshold: [0],
        rootMargin: '-' + topOffset + 'px 0px 0px 0px'
      });

      buyButtonObserver.observe(buyButton);
    }

    if (buyButton && 'IntersectionObserver' in window) {
      setupBuyButtonObserver();

      window.addEventListener('resize', function () {
        setupBuyButtonObserver();
        updateStickyVisibility(buyButton);
      }, { passive: true });

    } else if (buyButton) {
      function onScroll() {
        updateStickyVisibility(buyButton);
      }
      window.addEventListener('scroll', onScroll, { passive: true });
      window.addEventListener('resize', onScroll, { passive: true });
      onScroll();
    }

  });
})();
// Ende: Sticky CTA Scroll & Tidio

// Language Banner: liegt in snippets/revendo-lang-banner.liquid, weil er
// synchron vor dem ersten Paint laufen muss (sonst 0.133 CLS).

// Tidio-Fassade: Ein eigener Button liegt deckungsgleich auf Tidios Launcher
// (Styles in revendo-styles.css). Das Widget (~380 KB, 450–575 ms Main-Thread
// mobil) lädt erst beim Klick und öffnet sich dann direkt. Ausnahme: Seiten aus
// Einstellungen → Revendo Chat (Tidio) laden es sofort, damit seitenbasierte Flows
// («Visitor opens a specific page») greifen (snippets/revendo-tidio-now.liquid).
// Sonst laufen proaktive Flows erst nach dem Klick, auch «Visitor adds to a cart»:
// Tidio sieht einen Add nur, wenn es vorher geladen war. Auf der Homepage gibt es
// weiterhin keinen Chat.
(function () {
  if (document.body.classList.contains('index-template')) return;

  var labels = { de: 'Chat öffnen', en: 'Open chat', fr: 'Ouvrir le chat', it: 'Apri la chat' };
  var button = document.createElement('button');
  button.type = 'button';
  button.className = 'rv-chat-launcher';
  button.setAttribute('aria-label', labels[document.documentElement.lang.slice(0, 2)] || labels.de);
  button.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path fill="currentColor" d="M4 4h16a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H9l-5 4v-4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2z"/></svg>';

  var script = null;
  var wantsOpen = false;

  function loadTidio() {
    if (script) return;
    script = document.createElement('script');
    script.src = '//code.tidio.co/ss0oytboqjhrxto9upb8btz8eqg1kn0k.js';
    script.async = true;
    // Adblocker, Netz: Button für einen neuen Versuch freigeben.
    script.onerror = function () {
      script.remove();
      script = null;
      button.disabled = false;
    };
    document.body.appendChild(script);
  }

  document.addEventListener('tidioChat-ready', function () {
    // Erst nach dem tidioChat-ready-Listener des Sticky-CTA (hideTidio), sonst
    // versteckt der den eben angeforderten Chat wieder.
    setTimeout(function () {
      window.tidioChatApi.show();
      if (wantsOpen) {
        window.tidioChatApi.open();
      } else {
        // Sofort geladen (Seitenliste): Ein hideTidio()-Wunsch aus der Ladezeit kann
        // veraltet sein. revendo:chat-closed lässt PDP- und Verkaufen-Sticky ihren
        // aktuellen Zustand neu anwenden (design.mdc, «Schwebende Elemente»).
        document.dispatchEvent(new CustomEvent('revendo:chat-closed'));
      }
      button.remove();
    }, 0);
  }, { once: true });

  button.addEventListener('click', function () {
    wantsOpen = true;
    button.disabled = true;
    loadTidio();
  });

  if (document.body.hasAttribute('data-rv-tidio-now')) loadTidio();

  // Ebene: Tidio setzt inline `z-index: 999999999 !important` und liegt damit über
  // dem Cookie-Banner (2000000). CSS kommt dagegen nicht an, darum hier auf die Ebene
  // von Klaviyo (90000) setzen und halten, falls Tidio den Wert neu schreibt oder
  // das Element ersetzt. Regel: .cursor/rules/design.mdc, «Schwebende Elemente».
  var TIDIO_Z = '90000';
  var tidioEl = null;
  var styleObserver = new MutationObserver(function () {
    setTidioLayer();
  });

  function setTidioLayer() {
    if (tidioEl && tidioEl.style.getPropertyValue('z-index') !== TIDIO_Z) {
      tidioEl.style.setProperty('z-index', TIDIO_Z, 'important');
    }
  }

  new MutationObserver(function () {
    var el = document.getElementById('tidio-chat');
    if (!el || el === tidioEl) return;
    tidioEl = el;
    styleObserver.disconnect();
    styleObserver.observe(el, { attributes: true, attributeFilter: ['style'] });
    setTidioLayer();
  }).observe(document.body, { childList: true });

  // Position Mobil: Unterkante des Buttons auf 52px wie auf Desktop. Das Tidio-Panel
  // erlaubt das nur für Desktop; auf Mobil liegt der Button 14px über dem Rand, darum
  // 38px höher. Nur bei geschlossenem Chat, das offene Fenster bleibt unverändert.
  document.addEventListener('tidioChat-ready', function () {
    window.tidioChatApi.adjustStyles('#body.mobile #button.chat-closed { top: -38px !important; }');

    // Vorrang: Ein offener Chat wird nie verdeckt oder ausgeblendet. `rv-chat-open` am
    // body blendet per CSS Marketing-Flyouts aus; die Sticky-Logik (PDP, Verkaufen)
    // lässt den Chat stehen und blendet den Button erst nach `revendo:chat-closed` aus.
    window.tidioChatApi.on('open', function () {
      document.body.classList.add('rv-chat-open');
    });
    window.tidioChatApi.on('close', function () {
      document.body.classList.remove('rv-chat-open');
      document.dispatchEvent(new CustomEvent('revendo:chat-closed'));
    });
  });

  document.body.appendChild(button);
})();
// Ende: Tidio-Fassade

// Klaviyo Onsite: Deferred Loading nach erster Nutzerinteraktion
// ─────────────────────────────────────────────────────────────────────────────
// Klaviyo wird NICHT mehr über den Shopify App Embed Block geladen (dort deakti-
// viert), sondern nach der ersten Interaktion. Das Onsite-Bundle zieht rund 40
// weitere Chunks nach und war damit der grösste Einzelposten der ~513 Requests
// auf der Startseite.
//
// Der Fallback ist mit 3s kürzer als bei Tidio: Klaviyo transportiert Tracking
// (u. a. "Viewed Product" für Browse-Abandonment-Flows), Tidio nur ein Chat-
// Widget. Besucher, die vor Ablauf der 3s ohne jede Interaktion abspringen,
// werden onsite nicht mehr erfasst — Bestell- und Checkout-Events laufen davon
// unabhängig über Klaviyos eigenes Web-Pixel (Server + Web) weiter.
// ─────────────────────────────────────────────────────────────────────────────
(function () {
  var COMPANY_ID = 'VDxmP7';
  var loaded = false;

  function loadKlaviyo() {
    if (loaded) return;
    loaded = true;

    // Schützt vor Doppelladung, falls das App Embed im Theme-Editor wieder
    // aktiviert wird — dann bringt Shopify klaviyo.js bereits selbst mit.
    if (document.querySelector('script[src*="klaviyo.com/onsite/js"]')) return;

    var s = document.createElement('script');
    s.src = 'https://static.klaviyo.com/onsite/js/' + COMPANY_ID + '/klaviyo.js?company_id=' + COMPANY_ID;
    s.async = true;

    s.onload = function () {
      var payload = window.revendoKlaviyoIdentify;
      if (payload && window.klaviyo && typeof window.klaviyo.identify === 'function') {
        window.klaviyo.identify(payload);
      }
    };

    document.head.appendChild(s);
  }

  ['touchstart', 'mousemove', 'scroll', 'click', 'keydown'].forEach(function (evt) {
    window.addEventListener(evt, loadKlaviyo, { once: true, passive: true });
  });

  setTimeout(loadKlaviyo, 3000);
})();
// Ende: Klaviyo Deferred Loading

// Revendo: Collection-Beschreibung mobil auf- und zuklappen.
if (!customElements.get('revendo-collection-intro')) {
  customElements.define('revendo-collection-intro', class extends HTMLElement {
    connectedCallback() {
      const text = this.querySelector('.revendo-intro');
      const button = this.querySelector('.revendo-intro__toggle');
      if (!text || !button) return;
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      const mobile = matchMedia('(max-width: 749.98px)');
      // Liquid begrenzt lange Texte schon im ersten Bild (is-collapsible), stellt eine
      // führende Filterknopf-Zeile davor und schaltet den Knopf inline (onclick), damit
      // er auch ohne dieses Script wirkt. Hier nur nachmessen: passt der Text doch in
      // drei Zeilen, Begrenzung und Knopf entfernen.
      const update = () => {
        if (!this.isConnected) return;
        const limit = 3 * parseFloat(getComputedStyle(text).lineHeight);
        const collapsible = mobile.matches && text.scrollHeight > limit + 1;
        this.classList.toggle('is-collapsible', collapsible);
        button.hidden = !collapsible;
        const open = !collapsible || this.classList.contains('is-open');
        button.setAttribute('aria-expanded', String(open));
        button.textContent = open ? button.dataset.less : button.dataset.more;
      };
      // Auch Links hinter der Vorschau dürfen beim Tastaturfokus nicht unsichtbar bleiben.
      text.addEventListener('focusin', () => {
        this.classList.add('is-open');
        update();
      }, options);
      mobile.addEventListener('change', update, options);
      this.observer = new ResizeObserver(update);
      this.observer.observe(text);
      document.fonts.addEventListener('loadingdone', update, options);
      document.fonts.ready.then(update);
      update();
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.events?.abort();
    }
  });
}

// Revendo: Variant picker — in-place sync (no DOM swap flicker on mobile)
(function () {
  function escapeSelector(value) {
    if (typeof CSS !== 'undefined' && CSS.escape) return CSS.escape(String(value));
    return String(value).replace(/\\/g, '\\\\').replace(/"/g, '\\"');
  }

  function syncInnerIfChanged(oldEl, newEl) {
    if (oldEl && newEl && oldEl.innerHTML !== newEl.innerHTML) {
      oldEl.innerHTML = newEl.innerHTML;
    }
  }

  function syncVariantSelectsInPlace(oldRoot, newRoot) {
    if (!oldRoot || !newRoot) return false;

    // Dropdown-Picker: NiceSelect rendert eine eigene UI, die sich nicht
    // in-place aktualisieren lässt — auf den Original-Swap zurückfallen.
    if (oldRoot.querySelector('select[name^="options"]')) return false;

    var oldFieldsets = oldRoot.querySelectorAll('fieldset');
    var newFieldsets = newRoot.querySelectorAll('fieldset');
    if (oldFieldsets.length !== newFieldsets.length) return false;

    var newVariantData = newRoot.querySelector('[data-selected-variant]');
    var oldVariantData = oldRoot.querySelector('[data-selected-variant]');
    if (newVariantData && oldVariantData) {
      oldVariantData.textContent = newVariantData.textContent;
    }

    var newRadios = newRoot.querySelectorAll('input[type="radio"][data-option-value-id]');
    for (var i = 0; i < newRadios.length; i++) {
      var newInput = newRadios[i];
      var optionValueId = newInput.dataset.optionValueId;
      var oldInput = oldRoot.querySelector(
        'input[type="radio"][data-option-value-id="' + optionValueId + '"]'
      );
      if (!oldInput) return false;

      oldInput.checked = newInput.checked;
      oldInput.disabled = newInput.disabled;
      oldInput.classList.toggle('disabled', newInput.classList.contains('disabled'));

      // Sprungziel fuer den Wechsel auf verfuegbare Kombination haengt von
      // der aktuellen Selektion ab und muss bei jedem Sync mitkommen, sonst
      // springen Folgeklicks mit veralteten Zielen oder gar nicht.
      if (newInput.dataset.revendoJumpName) {
        oldInput.dataset.revendoJumpName = newInput.dataset.revendoJumpName;
        oldInput.dataset.revendoJumpValue = newInput.dataset.revendoJumpValue;
      } else {
        delete oldInput.dataset.revendoJumpName;
        delete oldInput.dataset.revendoJumpValue;
      }

      var newLabel = newRoot.querySelector('label[for="' + escapeSelector(newInput.id) + '"]');
      var oldLabel = oldRoot.querySelector('label[for="' + escapeSelector(oldInput.id) + '"]');
      if (newLabel && oldLabel) syncInnerIfChanged(oldLabel, newLabel);
    }

    for (var f = 0; f < newFieldsets.length; f++) {
      var newFs = newFieldsets[f];
      var oldFs = oldFieldsets[f];

      var newSel = newFs.querySelector('[data-selected-value]');
      var oldSel = oldFs.querySelector('[data-selected-value]');
      syncInnerIfChanged(oldSel, newSel);
    }

    syncConditionSelection(oldRoot);
    return true;
  }

  function syncConditionSelection(root) {
    if (!root?.querySelectorAll) return;
    root.querySelectorAll('fieldset').forEach(fieldset => {
      const input = fieldset.querySelector('input[type="radio"]:checked');
      if (!input) return;
      const selected = fieldset.querySelector('[data-selected-value]');
      if (selected && !selected.closest('[data-condition-selection]')) selected.textContent = input.value;
      const selection = fieldset.querySelector('[data-condition-selection]');
      if (!selection) return;
      const label = fieldset.querySelector('label[for="' + escapeSelector(input.id) + '"]');
      if (!label) return;
      selection.innerHTML = label.innerHTML;
      selection.querySelector('.revendo-variant-sold')?.classList.toggle('hidden', !input.classList.contains('disabled'));
    });
  }

  document.addEventListener('change', event => {
    if (event.target.type !== 'radio') return;
    const picker = event.target.closest?.('.revendo-variant-picker');
    const details = event.target.closest?.('.revendo-condition-select');
    if (!picker && !details) return;
    syncConditionSelection(picker || event.target.closest('variant-selects'));
    if (details) {
      details.open = false;
      details.querySelector('summary')?.focus({ preventScroll: true });
    }
  });

  document.addEventListener('click', event => {
    document.querySelectorAll('.revendo-condition-select[open]').forEach(details => {
      if (!details.contains(event.target)) details.open = false;
    });
  });

  document.addEventListener('keydown', event => {
    const details = event.target.closest?.('.revendo-condition-select');
    if (!details) return;
    if (event.key === 'Escape' && details.open) {
      event.preventDefault();
      event.stopPropagation();
      details.open = false;
      details.querySelector('summary').focus({ preventScroll: true });
    } else if (event.key === 'ArrowDown' && event.target.tagName === 'SUMMARY') {
      event.preventDefault();
      details.open = true;
      (details.querySelector('input:checked') || details.querySelector('input'))?.focus({ preventScroll: true });
    }
  });

  const variantResponses = new Map();

  function patchProductInfoVariantSync() {
    var ProductInfo = customElements.get('product-info');
    if (!ProductInfo || ProductInfo.prototype._revendoVariantSyncPatched) return;

    const originalRender = ProductInfo.prototype.renderProductInfo;
    ProductInfo.prototype.renderProductInfo = function (options) {
      if (!this.variantSelectors?.classList.contains('revendo-variant-picker')) {
        return originalRender.call(this, options);
      }
      const { requestUrl, targetId, callback } = options;
      this.abortController?.abort();
      const controller = new AbortController();
      this.abortController = controller;
      const cached = variantResponses.get(requestUrl);
      const response = cached && Date.now() - cached.time < 10000
        ? Promise.resolve(cached.text)
        : fetch(requestUrl, { signal: controller.signal }).then(response => {
            if (!response.ok) throw new Error(`Variant request failed: ${response.status}`);
            return response.text();
          });
      return response.then(text => {
        if (controller.signal.aborted || !this.isConnected) return;
        const html = new DOMParser().parseFromString(text, 'text/html');
        if (!html.querySelector('variant-selects [data-selected-variant]')) {
          throw new Error('Variant response is missing product data');
        }
        if (!cached || cached.text !== text || Date.now() - cached.time >= 10000) {
          variantResponses.delete(requestUrl);
          variantResponses.set(requestUrl, { text, time: Date.now() });
          if (variantResponses.size > 6) variantResponses.delete(variantResponses.keys().next().value);
        }
        this.pendingRequestUrl = null;
        callback(html);
        const target = document.getElementById(targetId);
        const details = target?.closest('.revendo-condition-select');
        const focusTarget = details && !details.open ? details.querySelector('summary') : target;
        focusTarget?.focus({ preventScroll: true });
      }).catch(error => {
        if (controller.signal.aborted || error.name === 'AbortError') return;
        this.pendingRequestUrl = null;
        this.productForm?.handleErrorMessage(window.cartStrings.error);
        console.error(error);
      });
    };

    var originalUpdate = ProductInfo.prototype.updateOptionValues;
    ProductInfo.prototype.updateOptionValues = function (html) {
      var newVariantSelects = html.querySelector('variant-selects');
      var oldVariantSelects = this.variantSelectors;
      if (newVariantSelects && oldVariantSelects && syncVariantSelectsInPlace(oldVariantSelects, newVariantSelects)) {
        return;
      }
      return originalUpdate.call(this, html);
    };
    ProductInfo.prototype._revendoVariantSyncPatched = true;
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, () => variantResponses.clear());
    }
  }

  if (typeof HTMLUpdateUtility !== 'undefined' && !HTMLUpdateUtility._revendoSwapPatched) {
    HTMLUpdateUtility._revendoSwapPatched = true;
    HTMLUpdateUtility.viewTransition = function (oldNode, newContent, preProcessCallbacks, postProcessCallbacks) {
      preProcessCallbacks?.forEach(function (callback) { callback(newContent); });
      var wrapper = document.createElement('div');
      HTMLUpdateUtility.setInnerHTML(wrapper, newContent.outerHTML);
      var newNode = wrapper.firstChild;
      var uniqueKey = Date.now();
      oldNode.querySelectorAll('[id], [form]').forEach(function (element) {
        if (element.id) element.id = element.id + '-' + uniqueKey;
        if (element.form) element.setAttribute('form', element.form.getAttribute('id') + '-' + uniqueKey);
      });
      // Hidden until the old node is out of flow, otherwise connectedCallback
      // of the new node forces a layout with both product-info elements stacked.
      // Inline display, not [hidden]: Ignite .block beats the hidden attribute.
      newNode.style.display = 'none';
      oldNode.parentNode.insertBefore(newNode, oldNode);
      oldNode.style.display = 'none';
      newNode.style.display = '';
      postProcessCallbacks?.forEach(function (callback) { callback(newNode); });
      setTimeout(function () { oldNode.remove(); }, 500);
    };
  }

  if (customElements.get('product-info')) {
    patchProductInfoVariantSync();
  } else {
    customElements.whenDefined('product-info').then(patchProductInfoVariantSync);
  }
  document.addEventListener('product-info:loaded', patchProductInfoVariantSync);

})();
// END Revendo: Variant picker sync

// Revendo: Breezy Jobs – Multicolumn Theme-Klassen auf Embed-Markup anwenden
(function () {
  var CARD_LINK_CLASSES = [
    'multicolumn-card',
    'responsive-card-padding',
    'overflow-hidden',
    'flex',
    'flex-col',
    'content-container',
    'gradient',
    'full-unstyled-link--foreground',
    'focus-this-inner-inset'
  ];

  function ensureClasses(el, classes) {
    classes.forEach(function (cls) {
      el.classList.add(cls);
    });
  }

  function extractJobParts(link) {
    var info = link.querySelector('.multicolumn-card__info');
    var heading = link.querySelector('h2');
    var meta = link.querySelector('ul.bzMeta');
    var applyButton = link.querySelector('.bzButtonApply');

    if (info) {
      if (!heading) heading = info.querySelector('h2');
      if (!meta) meta = info.querySelector('ul.bzMeta');
      if (!applyButton) applyButton = info.querySelector('.bzButtonApply');
      info.remove();
    }

    link.querySelectorAll('.banner__buttons').forEach(function (wrap) {
      wrap.remove();
    });

    return { heading: heading, meta: meta, applyButton: applyButton };
  }

  function styleJobItem(item, sectionScheme, cardScheme, showShadow, applyLabel) {
    item.classList.add('multicolumn-list__item', 'grid__item');
    item.classList.add(
      sectionScheme !== cardScheme ? 'color-schemes--different' : 'color-schemes--matching'
    );

    var link = item.querySelector(':scope > a');
    if (!link) return;

    var parts = extractJobParts(link);
    ensureClasses(link, CARD_LINK_CLASSES);
    link.classList.add('color-' + cardScheme);
    if (showShadow) {
      link.classList.add('card--shadow');
    } else {
      link.classList.remove('card--shadow');
    }
    link.style.setProperty('--responsive-card-padding', '3rem');

    var info = document.createElement('div');
    info.className =
      'multicolumn-card__info card-padding flex flex-col md:flex-row md:items-center md:justify-between gap-1 w-full';

    var body = document.createElement('div');
    body.className = 'flex flex-col gap-05 min-w-0 grow';

    if (parts.heading) {
      parts.heading.className =
        'multicolumn-card__heading lh-13 mt-0 mb-0 inline-richtext h5';
      body.appendChild(parts.heading);
    }

    if (parts.meta) {
      parts.meta.className =
        'list-unstyled bmrk-tags bmrk-tags--phat flex flex-wrap gap-05 t7 mb-0';
      body.appendChild(parts.meta);
    }

    if (body.childElementCount) {
      info.appendChild(body);
    }

    if (parts.applyButton) {
      parts.applyButton.className = 'bzButtonApply button button--primary';
      if (applyLabel) {
        parts.applyButton.textContent = applyLabel;
      }
      var btnWrap = document.createElement('div');
      btnWrap.className =
        'banner__buttons banner__buttons--multiple shrink-0 mt-1 md:mt-0 md:ml-2';
      btnWrap.appendChild(parts.applyButton);
      info.appendChild(btnWrap);
    }

    link.appendChild(info);
  }

  function styleBreezyJobs(container, observer) {
    if (!container) return;

    var list = container.querySelector('ul.bzOpeningsList');
    if (!list) return;

    var section = container.closest('.revendo-jobs');
    var sectionScheme = (section && section.dataset.revendoSectionColor) || 'scheme-1';
    var cardScheme = (section && section.dataset.revendoCardColor) || 'scheme-1';
    var showShadow = section && section.dataset.revendoCardShadow === 'true';
    var applyLabel = section && section.dataset.applyLabel;

    container.__revendoJobsStyling = true;
    if (observer) observer.disconnect();

    ensureClasses(list, [
      'multicolumn-list',
      'contains-content-container',
      'section-grid',
      'grid',
      'mb-0',
      'grid--1-col',
      'grid--1-col-desktop',
      'grid--1-col-tablet-down'
    ]);

    container.querySelectorAll('li.bzOpening').forEach(function (item) {
      styleJobItem(item, sectionScheme, cardScheme, showShadow, applyLabel);
    });

    if (observer) observer.observe(container, { childList: true, subtree: true });
    container.__revendoJobsStyling = false;
  }

  function initBreezyJobs() {
    var container = document.getElementById('bzOpeningsContainer');
    if (!container) return;

    if (container.__revendoJobsObserver) {
      styleBreezyJobs(container, container.__revendoJobsObserver);
      return;
    }

    var observer = new MutationObserver(function () {
      if (container.__revendoJobsStyling) return;
      styleBreezyJobs(container, observer);
    });

    observer.observe(container, { childList: true, subtree: true });
    container.__revendoJobsObserver = observer;
    styleBreezyJobs(container, observer);
  }

  document.addEventListener('DOMContentLoaded', initBreezyJobs);
  document.addEventListener('shopify:section:load', initBreezyJobs);
})();
// END Revendo: Breezy Jobs
// Revendo: Sidecart Wunschliste
(function () {
  'use strict';

  var PATHS = ['/apps/wishlist', '/apps/wishlist-1', '/apps/wishlist-2'];
  var PROXY_KEY = 'revendoWishlistProxy';
  var GUEST_KEY = 'revendoWishlistGuest';
  var PENDING_KEY = 'revendoWishlistPending';
  var resolving;

  function resolveProxy() {
    if (resolving) return resolving;
    var paths = PATHS.slice();
    try {
      var cached = localStorage.getItem(PROXY_KEY);
      if (paths.indexOf(cached) !== -1) paths.unshift(cached);
    } catch (e) { /* storage unavailable */ }
    resolving = paths.reduce(function (chain, path) {
      return chain.then(function (found) {
        if (found) return found;
        return fetch(path, { headers: { Accept: 'application/json' } })
          .then(function (res) { return res.ok ? res.json() : null; })
          .then(function (data) {
            return data && Array.isArray(data.items) && typeof data.requireLogin === 'boolean'
              ? { path: path, data: data } : null;
          }).catch(function () { return null; });
      });
    }, Promise.resolve(null)).then(function (found) {
      resolving = null;
      if (!found) throw new Error('wishlist unavailable');
      try { localStorage.setItem(PROXY_KEY, found.path); } catch (e) { /* storage unavailable */ }
      return found;
    });
    return resolving;
  }

  function rememberForLogin(action) {
    sessionStorage.setItem(PENDING_KEY, JSON.stringify({ action: action, at: Date.now() }));
    window.location.href = '/customer_authentication/login?return_to=' +
      encodeURIComponent(window.location.pathname + window.location.search);
  }

  function saveGuest(action) {
    var items = JSON.parse(localStorage.getItem(GUEST_KEY) || '[]');
    if (!Array.isArray(items)) throw new Error('invalid guest wishlist');
    var present = items.some(function (item) {
      return String(item.productId) === action.productId && String(item.variantId || '') === action.variantId;
    });
    if (!present) items.push({ productId: action.productId, productHandle: action.productHandle, variantId: action.variantId });
    localStorage.setItem(GUEST_KEY, JSON.stringify(items));
  }

  function moveToWishlist(btn) {
    btn.setAttribute('aria-pressed', 'true');
    btn.textContent = btn.dataset.addedLabel;
    var row = btn.closest('.cart-item');
    var remove = row && row.querySelector('cart-remove-button:not(.hidden) button');
    if (remove) remove.click();
    var header = document.querySelector('.rw-header-link[data-rw-bound="1"]');
    if (header) header.click();
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-rv-wishlist-add]');
    if (!btn || btn.disabled || btn.getAttribute('aria-pressed') === 'true') return;
    e.preventDefault();
    btn.disabled = true;
    var previousError = btn.nextElementSibling;
    if (previousError && previousError.hasAttribute('data-rv-wishlist-error')) previousError.textContent = '';
    var action = { intent: 'add', productId: btn.dataset.productId,
      productHandle: btn.dataset.productHandle, variantId: btn.dataset.variantId };
    resolveProxy().then(function (proxy) {
      if (!proxy.data.customerId) {
        if (proxy.data.requireLogin) { rememberForLogin(action); return; }
        saveGuest(action);
        moveToWishlist(btn);
        return;
      }
      return fetch(proxy.path, {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(action)
      }).then(function (res) {
        if (res.status === 401) { rememberForLogin(action); return null; }
        if (!res.ok) throw new Error('wishlist save failed');
        return res.json();
      }).then(function (data) {
        if (data === null) return;
        if (!data || data.ok !== true) throw new Error('invalid wishlist response');
        moveToWishlist(btn);
      });
    }).catch(function () {
      var message = btn.nextElementSibling;
      if (!message || !message.hasAttribute('data-rv-wishlist-error')) {
        message = document.createElement('span');
        message.setAttribute('data-rv-wishlist-error', '');
        message.setAttribute('role', 'status');
        btn.after(message);
      }
      message.textContent = btn.dataset.errorLabel;
    }).finally(function () { btn.disabled = false; });
  });
})();
// END Revendo: Sidecart Wunschliste

// Revendo: Preisformat – Tausender mit Apostroph (de-CH), seitenweit
// Shopify kennt kein money_format "ohne Rappen mit Apostroph", das Store-Format
// trennt darum mit Leerzeichen ("1 788 CHF"). Statt Liquid-Postprocessing an
// ~150 money-Ausgaben in 25 Dateien: ein Text-Reformat über die ganze Seite,
// begrenzt auf Textknoten mit "CHF" (Telefonnummern, Daten usw. bleiben
// unberührt). Format-unabhängig (Prefix "CHF 1 234.00" wie Suffix "1 234 CHF"),
// weil nur Ziffergruppen umgruppiert werden. Die Meta-Description formatiert
// snippets/revendo-seo-meta.liquid serverseitig, weil Google dort kein JS ausführt.
// ponytail: ein Reformat nach dem Rendern; sauberer wäre ein natives
// money_format mit Apostroph, falls Shopify es je anbietet – dann ersatzlos weg.
(function () {
  'use strict';

  // Nur Beträge direkt vor oder nach "CHF" umgruppieren: "1 788 CHF" /
  // "CHF 3,022.00" -> "1'788 CHF" / "CHF 3'022.00" (auch NBSP-Varianten).
  // "Seit 2024 100 Modelle ab 29 CHF" oder Telefonnummern im selben Text bleiben,
  // weil die Zifferngruppe nicht an "CHF" hängt. Komma zählt nur mit exakt 3
  // Folgeziffern als Tausendertrenner – ein Dezimalkomma ("3.022,00") bleibt.
  var SEP = /[ \u00A0\u202F,]/g;
  // Kein Lookbehind (?<!\d): Safari < 16.4 verwirft sonst die ganze Datei beim Parsen.
  var SUFFIX = /(^|\D)(\d{1,3}(?:[ \u00A0\u202F,]\d{3})+)(?!\d)(?=(?:\.\d{2}|\.[–-]{1,2})?[ \u00A0\u202F]*CHF)/g;
  var PREFIX = /(CHF[ \u00A0\u202F]*)(\d{1,3}(?:[ \u00A0\u202F,]\d{3})+)(?!\d)/g;
  var SKIP = { SCRIPT: 1, STYLE: 1, TEXTAREA: 1, NOSCRIPT: 1 };

  function group(digits) { return digits.replace(SEP, "'"); }

  function formatNode(node) {
    var text = node.textContent;
    if (text.indexOf('CHF') === -1 || !node.parentNode || SKIP[node.parentNode.nodeName]) return;
    var next = text
      .replace(SUFFIX, function (m, pre, digits) { return pre + group(digits); })
      .replace(PREFIX, function (m, chf, digits) { return chf + group(digits); });
    if (next !== text) node.textContent = next;
  }

  function formatTree(root) {
    if (root.nodeType === 3) return formatNode(root);
    if (root.nodeType !== 1) return;
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    var n;
    while ((n = walker.nextNode())) formatNode(n);
  }

  function start() {
    formatTree(document.body);
    // Warenkorb, Varianten-Wechsel, Filter usw. rendern Preise nach. formatNode
    // schreibt nur bei tatsaechlicher Aenderung -> keine Endlosschleife.
    new MutationObserver(function (records) {
      records.forEach(function (r) {
        if (r.type === 'characterData') formatNode(r.target);
        else r.addedNodes.forEach(formatTree);
      });
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
// END Revendo: Preisformat

// Revendo: PDP — Klick auf eine Zustand-Pill, deren Kombination mit
// der anderen Zustand-Option ausverkauft ist, springt auf die lagerstaerkste
// verfuegbare Kombination. Das Sprungziel steht serverseitig berechnet als
// data-revendo-jump-name/-value am Radio (revendo-variant-option-attrs.liquid).
// Capture-Listener: laeuft VOR dem change-Handler von <variant-selects>,
// dadurch liest das Theme direkt den korrigierten Zustand und rendert genau
// einmal — kein zweiter Fetch, kein Flackern.
(function () {
  // Merkt sich, ob der letzte Wechsel ein bewusster Klick auf eine als
  // ausverkauft markierte Pill war — dann zeigt Teil 2 die Sold-out-Ansicht
  // statt wegzuspringen (Benachrichtigung, bewusste Auswahl).
  var deliberateSoldOutClick = false;
  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!input || input.type !== 'radio' || !input.closest || !input.closest('variant-selects')) return;
    deliberateSoldOutClick = input.classList.contains('disabled');
    if (!input.dataset || !input.dataset.revendoJumpName || !input.checked) return;
    var root = input.closest('variant-selects');
    var radios = root.querySelectorAll('input[type="radio"]');
    for (var i = 0; i < radios.length; i++) {
      var radio = radios[i];
      if (
        radio.name.trim() === input.dataset.revendoJumpName &&
        radio.value === input.dataset.revendoJumpValue &&
        !radio.disabled
      ) {
        radio.checked = true;
        break;
      }
    }
  }, true);

  // Teil 2: Steht die Selektion auf einer ausverkauften Kombination, obwohl
  // die gewaehlte Pill selbst verfuegbar waere, traegt die angehakte Pill das
  // serverseitig berechnete Sprungziel - einmal "change" ausloesen, danach
  // laeuft alles wie bei einem echten Klick. Faelle: Sold-out-Landing per
  // ?variant=-Link, Geschwister-Wechsel auf Combined-Listing-Seiten, und
  // schnelle Folgeklicks, deren Pill noch veraltete Sprungziele aus dem
  // vorherigen Rendering trug. Terminiert immer: das Sprungziel ist
  // verfuegbar, dessen Rendering traegt auf der angehakten Pill keine
  // Sprung-Attribute mehr, und ohne existierendes, noch nicht angehaktes
  // Sprungziel wird gar nicht erst ausgeloest.
  function jumpToAvailableCombination() {
    if (window.Shopify && window.Shopify.designMode) return;
    if (deliberateSoldOutClick) return;
    var checked = document.querySelector(
      'variant-selects input[type="radio"]:checked[data-revendo-jump-name]'
    );
    if (!checked) return;
    var root = checked.closest('variant-selects');
    if (!root) return;
    var radios = root.querySelectorAll('input[type="radio"]');
    for (var i = 0; i < radios.length; i++) {
      if (
        radios[i].name.trim() === checked.dataset.revendoJumpName &&
        radios[i].value === checked.dataset.revendoJumpValue &&
        !radios[i].checked &&
        !radios[i].disabled
      ) {
        checked.dispatchEvent(new Event('change', { bubbles: true }));
        return;
      }
    }
  }
  function armJump() {
    setTimeout(jumpToAvailableCombination, 0);
  }
  // Wartet auf product-info UND product-form (beide lazy geladen): ohne
  // product-info verpufft der Wechsel, ohne product-form fehlt danach der
  // Warenkorb-Button-Toggle.
  if (window.customElements && customElements.whenDefined) {
    Promise.all([
      customElements.whenDefined('product-info'),
      customElements.whenDefined('product-form'),
    ]).then(function () {
      armJump();
      document.addEventListener('product-info:loaded', armJump);
      if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.variantChange, armJump);
      }
    });
  }
})();
// END Revendo: PDP Sprung auf verfuegbare Kombination

// Revendo: Filialverfügbarkeit (snippets/revendo-stock-indicator.liquid).
// 1) Hover-Popup klappt nach oben, wenn es unten aus dem Viewport laufen wuerde
//    (Klasse rsi--up, CSS in revendo-styles.css). Ereignisgesteuert, kein Layout beim Laden.
// 2) PDP: der custom_liquid-Block wird von Ignite beim Variantenwechsel nicht
//    aktualisiert – wir tauschen ihn aus der neu gerenderten Section aus.
(function () {
  document.addEventListener('pointerover', function (e) {
    var c = e.target.closest && e.target.closest('.rsi');
    if (!c) return;
    var p = c.querySelector('.popup-wrap-box');
    if (!p) return;
    c.classList.toggle('rsi--up', c.getBoundingClientRect().top + p.offsetHeight > window.innerHeight);
  });
  function syncPickupTitle(box) {
    var details = box.closest('details');
    var title = details && details.querySelector('.accordion__title');
    var template = box.querySelector('template[data-revendo-fulfillment-title]');
    if (title && template) title.replaceChildren(template.content.cloneNode(true));
  }
  function initPickupTitles() {
    document.querySelectorAll('.filial-box').forEach(syncPickupTitle);
  }
  // Der erste Titel steht schon per Inline-Script im Snippet. Hier nur die Faelle, in denen
  // das Markup per innerHTML nachgeladen wird und Inline-Scripts nicht laufen (Quick Add, Editor).
  initPickupTitles();
  document.addEventListener('product-info:loaded', initPickupTitles);
  document.addEventListener('shopify:section:load', initPickupTitles);
  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!input.matches('form[action*="/cart/add"] input[name="id"]') || input.value) return;
    var productInfo = input.closest('product-info');
    if (!productInfo) return;
    productInfo.querySelectorAll('.rsi--pdp, .filial-box').forEach(function (node) {
      node.hidden = true;
    });
  });
  if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;
  subscribe(PUB_SUB_EVENTS.variantChange, function (event) {
    var data = event && event.data;
    if (!data || !data.html || !data.variant) return;
    document.querySelectorAll('product-info').forEach(function (productInfo) {
      // Quick Add praefixt dataset.section mit 'quickadd-' und legt die Original-ID,
      // die variantChange meldet, in dataset.originalSection ab.
      var section = productInfo.dataset.originalSection || productInfo.dataset.section;
      if (section !== String(data.sectionId)) return;
      var input = productInfo.querySelector('form[action*="/cart/add"] input[name="id"]');
      if (!input || input.value !== String(data.variant.id)) return;
      ['.rsi--pdp', '.filial-box'].forEach(function (selector) {
        var current = productInfo.querySelector(selector);
        var next = data.html.querySelector(selector);
        if (current && next) current.replaceWith(next.cloneNode(true));
      });
      var pickup = productInfo.querySelector('.filial-box');
      if (pickup) syncPickupTitle(pickup);
    });
  });
})();
// END Revendo: Filialverfügbarkeit

// Keep the Wishlist app's buttons and event handlers; only arrange the PDP actions.
(function () {
  var observedProducts = new WeakSet();
  // Kein :has() im Selektor: ältere Browser werfen dort statt nichts zu finden.
  function purchaseProducts() {
    return Array.from(document.querySelectorAll('product-info')).filter(function (productInfo) {
      return productInfo.querySelector('.revendo-pdp-purchase, .revendo-variant-picker');
    });
  }
  function enhancePurchase() {
    purchaseProducts().forEach(function (productInfo) {
      var row = productInfo.querySelector('.product-form__buttons > .flex.gap-1');
      if (!row) return;
      row.classList.add('revendo-pdp-purchase');
      var heart = productInfo.querySelector('[data-rw-toggle]:not(.rw-heart--card)');
      if (heart && heart.parentElement !== row) row.appendChild(heart);
      // Glocke und Benachrichtigungs-Text haengen am Geraete-Picker.
      if (!productInfo.querySelector('.revendo-variant-picker')) return;
      var bell = productInfo.querySelector('.rw-bis-button');
      if (!bell) return;
      if (!bell.querySelector('.revendo-notify-icon')) {
        bell.insertAdjacentHTML('afterbegin', '<svg class="icon revendo-notify-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M18 8a6 6 0 0 0-12 0c0 7-3 7-3 9h18c0-2-3-2-3-9M10 21h4"/></svg>');
      }
      if (!bell.querySelector('.revendo-notify-label')) {
        var caption = document.createElement('span');
        caption.className = 'revendo-notify-label';
        caption.textContent = productInfo.querySelector('.revendo-variant-picker').dataset.notifyLabel;
        bell.appendChild(caption);
      }
      if (bell.parentElement !== row) row.appendChild(bell);
      var picker = productInfo.querySelector('.revendo-variant-picker');
      var variantData = picker.querySelector('[data-selected-variant]');
      var variant = variantData ? JSON.parse(variantData.textContent || 'null') : null;
      [heart, bell].filter(Boolean).forEach(function (button) {
        button.dataset.variantId = variant ? String(variant.id) : '';
        button.dataset.productId = picker.dataset.productId;
      });
      // An impossible combination has no variant to subscribe to.
      if (heart) heart.classList.toggle('rw-hidden', !variant || !variant.available);
      bell.classList.toggle('rw-hidden', !variant || variant.available);
      row.classList.toggle('revendo-pdp-purchase--unavailable', !variant || !variant.available);
    });
  }
  function observeProducts() {
    enhancePurchase();
    purchaseProducts().forEach(function (productInfo) {
      if (observedProducts.has(productInfo)) return;
      observedProducts.add(productInfo);
      // App controls can arrive after the theme; observe only this product, never the body.
      new MutationObserver(function (records) {
        if (records.some(function (record) {
          return Array.from(record.addedNodes).some(function (node) {
            return node.nodeType === 1 && (node.matches('.rw-bis-button, [data-rw-toggle]') || node.querySelector('.rw-bis-button, [data-rw-toggle]'));
          });
        })) enhancePurchase();
      }).observe(productInfo, { childList: true, subtree: true });
    });
  }
  function init() {
    observeProducts();
    document.addEventListener('product-info:loaded', observeProducts);
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, enhancePurchase);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();

(function () {
  function openMarkedPopup() {
    var trigger = document.querySelector('[data-revendo-open-popup]');
    if (!trigger) return;
    var popup = document.querySelector('custom-popup[data-popup-trigger-id="' + trigger.getAttribute('data-revendo-open-popup') + '"]');
    if (popup && typeof popup.show === 'function') popup.show();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', openMarkedPopup, { once: true });
  else openMarkedPopup();
})();
// Revendo: campaign boundaries also apply to cached pages, open tabs and facet results.
if (!customElements.get('revendo-mobile-promotion')) {
  customElements.define('revendo-mobile-promotion', class extends HTMLElement {
    connectedCallback() {
      this.update = () => {
        const now = Date.now() / 1000;
        let active = false;
        this.querySelectorAll('[data-mobile-offer]').forEach(offer => {
          const visible = !active && now >= Number(offer.dataset.start) && now < Number(offer.dataset.end);
          offer.hidden = !visible;
          active = active || visible;
        });
        this.querySelector('[data-mobile-regular]').hidden = active;
      };
      this.update();
      this.timer = setInterval(this.update, 1000);
      document.addEventListener('visibilitychange', this.update);
      if (this.closest('product-info') && typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
          const parent = this.closest('product-info');
          if (!parent || String(parent.dataset.section) !== String(data.sectionId)) return;
          const next = data.html.querySelector('revendo-mobile-promotion[data-mode="activation"]');
          if (next) this.replaceWith(next.cloneNode(true));
        });
      }
    }
    disconnectedCallback() {
      clearInterval(this.timer);
      document.removeEventListener('visibilitychange', this.update);
      this.unsubscribe?.();
    }
  });
}

// Revendo: Suche messen (snippets/revendo-search-collection-match.liquid,
// snippets/revendo-popular-searches.liquid).
// Littledata sendet view_search_results bei jedem Stapel sichtbar gewordener
// Produkte (~14× pro Sitzung) und für die Suchliste nie view_item_list. Aus diesen
// Daten lassen sich weder die Zahl der Suchen noch eine Klickrate ablesen. Deshalb
// hier genau ein "search" pro Ergebnisseite und ein "select_content" pro Klick auf
// Kategorie-Treffer oder Vorschlag, über Littledatas gtag (gleiche Client-ID).
(function () {
  var GA4 = 'G-P9EMSGBYTP';

  function send(name, params) {
    params.send_to = GA4;
    window.gtag('event', name, params);
  }

  // gtag kommt asynchron aus der Littledata-App. Erst senden, wenn das GA4-Ziel
  // konfiguriert ist, sonst verwirft gtag.js das Event. Nach 10 s aufgeben.
  function whenReady(callback, tries) {
    if (window.gtag && window.google_tag_manager && window.google_tag_manager[GA4]) return callback();
    if ((tries || 0) < 40) setTimeout(function () { whenReady(callback, (tries || 0) + 1); }, 250);
  }

  function init() {
    var results = document.querySelector('[data-revendo-search-term]');
    if (results) {
      whenReady(function () {
        send('search', {
          search_term: results.dataset.revendoSearchTerm,
          search_results: Number(results.dataset.revendoSearchResults),
          search_collection: results.dataset.revendoSearchCollection || '(keine)'
        });
      });
    }

    document.addEventListener('click', function (event) {
      var link = event.target.closest('[data-revendo-search-click]');
      if (!link || !window.gtag) return;
      send('select_content', {
        content_type: link.dataset.revendoSearchClick,
        content_id: link.dataset.revendoSearchId,
        transport_type: 'beacon'
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();

// Revendo: Mobile Suche einklappen (snippets/revendo-mobile-search-toggle.liquid,
// Animation in revendo-styles.css). Ignites StickyHeader setzt die Scroll-Klassen
// selbst; hier nur die Zeilenhöhe für die Animation und der Tap auf die Lupe.
(function () {
  function init() {
    var header = document.querySelector('.section-header');
    var toggle = header && header.querySelector('[data-revendo-search-toggle]');
    var bar = header && header.querySelector('.header__search-bar');
    var wrapper = header && header.querySelector('sticky-header');
    if (!toggle || !bar || !wrapper) return;

    // offsetTop/offsetHeight ignorieren transforms, die Messung stimmt also auch
    // im eingeklappten Zustand. Nur bei echter Grössenänderung neu messen.
    function measure() {
      var full = wrapper.offsetHeight;
      var top = bar.offsetTop;
      if (!full || !top) return;
      header.style.setProperty('--revendo-search-row', full - top + 'px');
      header.style.setProperty('--revendo-search-collapse', (top / full).toFixed(4));
    }
    measure();
    if (window.ResizeObserver) new ResizeObserver(measure).observe(wrapper);

    toggle.addEventListener('click', function () {
      header.classList.remove('scrolling-down');
      // Synchron im Tap, sonst öffnet iOS die Tastatur nicht.
      var input = bar.querySelector('input[type="search"]');
      if (input) input.focus({ preventScroll: true });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();

// Revendo: "Beliebte Suchbegriffe" auf iPhone antippbar halten
// (snippets/revendo-popular-searches.liquid). Die Liste ist nur per CSS
// :focus-within sichtbar. Safari fokussiert angetippte Links nicht: das Suchfeld
// verliert beim Antippen den Fokus, die Liste verschwindet vor dem click, und es
// passiert nichts. mousedown verhindern hält den Fokus im Feld, der click kommt an.
document.addEventListener('mousedown', function (event) {
  if (event.target.closest('.predictive-search--suggestions-desktop a')) event.preventDefault();
});

// Revendo: mobile Sortier- und Filialleiste (snippets/revendo-mobile-sortbar.liquid).
// Die beiden Selects sind Stellvertreter: facets.js wertet mobil nur das Drawer-
// Formular aus. Eine Wahl wird dorthin übertragen und dort ausgelöst; nach jedem
// Neu-Rendern der Facetten (Filter, „Alle entfernen“, Zurück) gleicht sync() die
// Leiste wieder an den Drawer an.
(function () {
  var STORE = 'filter.p.m.custom.available_in_stores';

  function drawerForm() {
    return document.getElementById('FacetFiltersFormMobile');
  }
  function storeBoxes(form) {
    return Array.from(form.querySelectorAll('input[type="checkbox"][name="' + STORE + '"]'));
  }
  function showSelected(select) {
    var label = select.parentElement.querySelector('[data-revendo-sortbar-label]');
    var text = select.selectedOptions[0] ? select.selectedOptions[0].textContent.trim() : '';
    if (label && label.textContent !== text) label.textContent = text;
  }

  function sync() {
    var form = drawerForm();
    if (!form) return;
    var sortProxy = document.querySelector('[data-revendo-sort-proxy]');
    var sortSource = form.querySelector('select[name="sort_by"]');
    if (sortProxy && sortSource && sortProxy.value !== sortSource.value) {
      sortProxy.value = sortSource.value;
      showSelected(sortProxy);
    }
    var storeProxy = document.querySelector('[data-revendo-store-proxy]');
    if (!storeProxy) return;
    var boxes = storeBoxes(form);
    var active = '';
    Array.from(storeProxy.options).forEach(function (option) {
      var box = option.value && boxes.find(function (b) { return b.value === option.value; });
      if (!box) return;
      option.disabled = box.disabled && !box.checked;
      if (box.checked && !active) active = option.value;
    });
    if (storeProxy.value !== active) {
      storeProxy.value = active;
      showSelected(storeProxy);
    }
  }

  document.addEventListener('change', function (event) {
    var select = event.target;
    var form = drawerForm();
    if (!form || !select.matches('[data-revendo-sort-proxy], [data-revendo-store-proxy]')) return;
    showSelected(select);
    var target = form;
    if (select.matches('[data-revendo-sort-proxy]')) {
      target = form.querySelector('select[name="sort_by"]');
      if (!target) return;
      target.value = select.value;
    } else {
      storeBoxes(form).forEach(function (box) {
        box.checked = box.value === (select.value || select.dataset.revendoPostversand);
        if (box.checked) target = box;
      });
    }
    target.dispatchEvent(new Event('input', { bubbles: true }));
  });

  function init() {
    var form = drawerForm();
    if (!form || !document.querySelector('.revendo-sortbar')) return;
    var queued = false;
    new MutationObserver(function () {
      if (queued) return;
      queued = true;
      requestAnimationFrame(function () {
        queued = false;
        sync();
      });
    }).observe(form, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
// END Revendo: mobile Sortier- und Filialleiste

// Revendo: Facetten-Anfragen — nur die letzte Auswahl darf Ergebnisse ersetzen.
// Ignite rendert parallele Antworten sonst in Ankunftsreihenfolge und behandelt
// HTTP-/Netzwerkfehler nicht. Cache und Darstellung bleiben bei Ignite.
if (document.querySelector('facet-filters-form')) {
  customElements.whenDefined('facet-filters-form').then(function () {
    const Facets = customElements.get('facet-filters-form');
    let controller;
    let revision = 0;
    let historyChangedAt = 0;
    let pendingSubmit;
    const renderPage = Facets.renderPage;
    const renderCache = Facets.renderSectionFromCache;
    const renderFilters = Facets.renderFilters;
    const submit = Facets.prototype.onSubmitHandler;
    const createSearchParams = Facets.prototype.createSearchParams;

    function cancelPending() {
      revision++;
      controller?.abort();
    }
    function setBusy(busy) {
      document.getElementById('ProductGridContainer')?.setAttribute('aria-busy', String(busy));
    }
    function setError(failed) {
      document.querySelectorAll('[data-revendo-facet-error]').forEach(function (element) {
        element.hidden = !failed;
      });
      const grid = document.getElementById('ProductGridContainer');
      if (grid) grid.hidden = failed;
    }

    Facets.renderPage = function (...args) {
      cancelPending();
      setError(false);
      setBusy(true);
      return renderPage.apply(this, args);
    };
    Facets.renderSectionFromCache = function (...args) {
      const result = renderCache.apply(this, args);
      const infiniteScroll = document.querySelector('infinite-scroll');
      if (infiniteScroll?.destroy) {
        infiniteScroll.destroy();
        infiniteScroll.init();
      }
      setBusy(false);
      return result;
    };
    Facets.renderFilters = function (html, event) {
      const parsed = typeof html === 'string' ? new DOMParser().parseFromString(html, 'text/html') : html;
      const params = new URLSearchParams(Facets.searchParamsPrev);
      // Shopify lässt bei null Treffern ganze Facetten weg. Aktive Gruppen
      // behalten, sonst löscht die nächste Preisänderung unbemerkt die Auswahl.
      document.querySelectorAll('#FacetFiltersForm .js-filter, #FacetFiltersFormMobile .js-filter').forEach(function (group) {
        if (parsed.getElementById(group.id)) return;
        const selected = Array.from(group.querySelectorAll('input[type="checkbox"]'))
          .filter(input => params.getAll(input.name).includes(input.value));
        if (!selected.length) return;
        const form = parsed.getElementById(group.closest('form').id);
        const anchor = form?.querySelector('.js-filter');
        if (!anchor) return;
        const retained = group.cloneNode(true);
        retained.querySelectorAll('input[type="checkbox"]').forEach(function (input) {
          input.checked = params.getAll(input.name).includes(input.value);
          input.toggleAttribute('checked', input.checked);
          input.disabled = !input.checked;
          input.labels?.forEach(label => label.classList.toggle('disabled', input.disabled));
        });
        // Frühere Trefferzahlen gelten für diese leere Kombination nicht mehr.
        retained.querySelectorAll('.facet__results').forEach(el => { el.textContent = '(0)'; });
        retained.querySelectorAll('label').forEach(function (label) {
          const text = label.querySelector('.facet-checkbox__text-label');
          if (text) label.querySelectorAll('.visually-hidden').forEach(el => { el.textContent = text.textContent; });
        });
        const siblings = Array.from(group.parentElement.children);
        const next = siblings.slice(siblings.indexOf(group) + 1)
          .map(sibling => parsed.getElementById(sibling.id)).find(Boolean);
        if (next) next.before(retained);
        else anchor.parentElement.append(retained);
      });
      const count = new Set(Array.from(params).filter(([name, value]) => name.startsWith('filter.') && value)
        .map(([name, value]) => name.startsWith('filter.v.price.') ? 'price' : name + '=' + value)).size;
      const badge = parsed.querySelector('.revendo-sortbar__count');
      if (badge) badge.textContent = count;
      const result = renderFilters.call(this, parsed, event);
      const storeBar = parsed.querySelector('.revendo-sortbar--store');
      if (storeBar) {
        const current = document.querySelector('.revendo-sortbar--store');
        const focused = current?.contains(document.activeElement);
        if (current) current.replaceWith(storeBar);
        else document.querySelector('[data-revendo-facet-error]')?.before(storeBar);
        if (focused) storeBar.querySelector('select')?.focus({ preventScroll: true });
      }
      return result;
    };
    // Auch ein direkt geöffneter Null-Treffer-Link hat keine Checkbox-Gruppen.
    // Eine Preis-/Sortieränderung darf deshalb seine übrigen URL-Filter nicht löschen.
    Facets.prototype.createSearchParams = function (form, ...args) {
      const params = new URLSearchParams(createSearchParams.call(this, form, ...args));
      if (['FacetFiltersForm', 'FacetFiltersFormMobile'].includes(form.id)) {
        const renderedNames = new Set(Array.from(document.querySelectorAll('facet-filters-form [name]'), input => input.name));
        new URLSearchParams(Facets.searchParamsPrev).forEach(function (value, name) {
          if (name.startsWith('filter.') && !renderedNames.has(name) && !params.getAll(name).includes(value)) {
            params.append(name, value);
          }
        });
      }
      return params.toString();
    };
    Facets.renderSectionFromFetch = async function (url, event) {
      controller = new AbortController();
      const requestController = controller;
      const timeout = setTimeout(() => requestController.abort(), 20000);
      const requestRevision = revision;
      try {
        const response = await fetch(url, { signal: controller.signal });
        if (!response.ok) throw new Error('Facets HTTP ' + response.status);
        const html = await response.text();
        if (requestRevision !== revision) return;
        Facets.filterData.push({ html, url });
        Facets.renderSectionFromCache(entry => entry.url === url, event);
      } catch (error) {
        if (requestRevision !== revision) return;
        Facets.filterData = Facets.filterData.filter(entry => entry.url !== url);
        setBusy(false);
        setError(true);
        document.querySelectorAll('.js-product-count').forEach(el => el.classList.remove('loading'));
        document.querySelectorAll('.facets-container .loading__spinner, facet-filters-form .loading__spinner')
          .forEach(el => el.classList.add('hidden'));
        Facets.toggleActiveFacets(false);
      } finally {
        clearTimeout(timeout);
      }
    };

    // Schon während Ignites Debounce eine alte Antwort verwerfen, sonst ersetzt
    // sie die gerade angeklickten Checkboxen vor deren Formularauswertung.
    function latestChoice(event) {
      if (!event.target.closest('facet-filters-form')) return;
      cancelPending();
      pendingSubmit = event;
    }
    document.addEventListener('input', latestChoice, true);
    // Ignites NiceSelect (Desktop-Sortierung) feuert nur change. facets.js reicht
    // change nur für Sortier-Selects weiter; ein change beim Verlassen des
    // Preisfelds darf die laufende Anfrage nicht abbrechen.
    document.addEventListener('change', function (event) {
      if (event.target.matches?.('select.facet-filters__sort')) latestChoice(event);
    }, true);
    Facets.prototype.onSubmitHandler = function (event) {
      if (event.timeStamp < historyChangedAt || (pendingSubmit && event.target !== pendingSubmit.target)) return;
      return submit.call(this, event);
    };
    window.addEventListener('popstate', function () {
      historyChangedAt = performance.now();
      pendingSubmit = null;
      cancelPending();
    }, true);
    document.addEventListener('click', function (event) {
      if (event.target.closest('[data-revendo-facet-retry]')) {
        Facets.renderPage(Facets.searchParamsPrev, null, false);
      }
    });
  });
}
// END Revendo: Facetten-Anfragen

// Revendo: Desktop-Filialwahl auch mit Tastatur; native Radios bleiben fokussierbar.
document.addEventListener('keydown', function (event) {
  const dropdown = event.target.closest('.verfugbar-dropdown');
  if (!dropdown) return;
  const toggle = dropdown.querySelector('.verfugbar-dropdown-toggle');
  if (event.key === 'Escape') {
    event.preventDefault();
    dropdown.classList.remove('open');
    toggle.setAttribute('aria-expanded', 'false');
    toggle.focus();
  } else if (event.target === toggle && event.key === 'ArrowDown') {
    event.preventDefault();
    if (!dropdown.classList.contains('open')) toggle.click();
    (dropdown.querySelector('input:checked:not(:disabled)') || dropdown.querySelector('input[type="radio"]:not(:disabled)'))?.focus();
  }
});
document.addEventListener('change', function (event) {
  if (event.target.matches('.verfugbar-filter-checkbox') && document.activeElement === event.target) {
    event.target.closest('.verfugbar-dropdown')?.querySelector('.verfugbar-dropdown-toggle')?.focus();
  }
});

// Revendo Impact: bei Optik Neu den Fussabdruck statt der Einsparung zeigen. Akku spielt keine Rolle.
// Neu + gebrauchter Akku hat oft keine Variante, die Varianten-ID bleibt dann leer.
function revendoImpactShowNew(root, isNew) {
  root.querySelectorAll('[data-revendo-impact-view]').forEach(function (view) {
    view.hidden = (view.getAttribute('data-revendo-impact-view') === 'footprint') !== isNew;
  });
}
document.addEventListener('change', function (event) {
  const opticalField = event.target.closest('[data-revendo-option="condition"]');
  const variantInput = event.target.matches('input[name="id"]');
  if (!opticalField && !variantInput) return;
  const root = document.querySelector('[data-revendo-impact]');
  if (!root) return;
  const checked = document.querySelector('[data-revendo-option="condition"] input:checked');
  if (checked) {
    revendoImpactShowNew(root, (root.getAttribute('data-revendo-impact-new') || '').split('|').indexOf(checked.value) !== -1);
    return;
  }
  if (!variantInput) return;
  if (!root._revendoImpactMap) {
    try {
      root._revendoImpactMap = JSON.parse(root.querySelector('[data-revendo-impact-variants]')?.textContent || '{}');
    } catch (error) {
      root._revendoImpactMap = {};
    }
  }
  const info = root._revendoImpactMap[event.target.value];
  revendoImpactShowNew(root, !!(info && info.is_new));
});

// Revendo: Typeform repair completion, using the shop's existing GA4 session.
(function () {
  var GA4 = 'G-P9EMSGBYTP';
  var forms = ['JcdKkk03', 'oRLDTn7N', 'WriFxx3e', 'Ml4UKqbv'];
  var popups = new Map();
  var sent = new Set();
  var sdk;

  function loadSdk() {
    if (window.tf && window.tf.createPopup) return Promise.resolve(window.tf);
    if (sdk) return sdk;
    sdk = new Promise(function (resolve, reject) {
      // Without the SDK stylesheet the popup renders unstyled below the footer.
      var css = document.createElement('link');
      css.rel = 'stylesheet';
      css.href = 'https://embed.typeform.com/next/css/popup.css';
      document.head.appendChild(css);
      var script = document.createElement('script');
      script.src = 'https://embed.typeform.com/next/embed.js';
      var timeout = setTimeout(function () { reject(new Error('Typeform SDK timeout')); }, 10000);
      script.onload = function () {
        clearTimeout(timeout);
        if (window.tf && window.tf.createPopup) resolve(window.tf);
        else reject(new Error('Typeform SDK unavailable'));
      };
      script.onerror = function (error) { clearTimeout(timeout); reject(error); };
      document.head.appendChild(script);
    }).catch(function (error) { sdk = null; throw error; });
    return sdk;
  }

  function track(formId, responseId, tries) {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    // Never override the shop's consent settings; no form answers leave Typeform.
    if (!privacy || !privacy.analyticsProcessingAllowed()) return;
    var key = formId + ':' + responseId;
    if (sent.has(key)) return;
    if (!window.gtag || !window.google_tag_manager || !window.google_tag_manager[GA4]) {
      if ((tries || 0) < 40) setTimeout(function () { track(formId, responseId, (tries || 0) + 1); }, 250);
      return;
    }
    sent.add(key);
    window.gtag('event', 'repair_form_submitted', {
      send_to: GA4,
      form_id: formId,
      form_provider: 'typeform',
      transport_type: 'beacon'
    });
  }

  document.addEventListener('click', function (event) {
    if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    var link = event.target.closest('a[href]');
    if (!link || link.hasAttribute('download')) return;
    var url = new URL(link.href, window.location.href);
    var match = url.pathname.match(/^\/to\/([a-zA-Z0-9]+)\/?$/);
    if (url.origin !== 'https://form.typeform.com' || !match || !forms.includes(match[1])) return;
    event.preventDefault();
    var formId = match[1];
    // Keep explicit language/hidden parameters on translated links intact.
    var key = url.href;
    loadSdk().then(function (tf) {
      if (!popups.has(key)) {
        var lastQuestion;
        popups.set(key, tf.createPopup(formId, {
          keepSession: true,
          tracking: Object.fromEntries(url.searchParams),
          hidden: Object.fromEntries(new URLSearchParams(url.hash.slice(1))),
          onQuestionChanged: function (data) {
            if (data.formId === formId) lastQuestion = data.ref;
          },
          onSubmit: function (data) {
            if (data.formId !== formId || typeof data.responseId !== 'string' || !data.responseId) return;
            // ponytail: JcdKkk03 also submits rejected AGBs. Only the final statement
            // after acceptance (or its success ending) qualifies. Recheck refs when
            // changing Typeform logic; a server-side verified response is the upgrade.
            if (formId === 'JcdKkk03' && ![
              '4c38f4cc-cab7-4add-a964-6946e91ca2e3',
              '66dfba2e-2b93-4395-bdfd-7f1adc700bf6'
            ].includes(lastQuestion)) return;
            track(formId, data.responseId);
          },
          onClose: function () { link.focus(); }
        }));
      }
      popups.get(key).open();
    }).catch(function () { window.location.assign(url.href); });
  });
})();

// Revendo: PDP Qualitaets-Badge (sections/revendo-pdp-quality-badge.liquid).
// Die Section steht im Template nach `main`, der Badge gehoert aber auf das Hauptbild.
// Wir haengen ihn in den Galerie-Slider: neben der Bildliste, damit der Variantenwechsel
// (tauscht nur die <ul>) ihn nicht entfernt. Neu bei Produkt-Swap und im Theme-Editor.
(function () {
  var badge = null;

  function placeQualityBadge() {
    var fresh = document.querySelector('.revendo-pdp-quality-badge [data-revendo-gallery-badge]');
    if (fresh) badge = fresh;
    var gallery = document.querySelector('product-info[id^="MainProduct"] [id^="GalleryViewer-"]');
    if (!badge || !gallery || badge.parentNode === gallery) return;
    gallery.querySelectorAll('[data-revendo-gallery-badge]').forEach(function (old) { old.remove(); });
    gallery.appendChild(badge);
  }

  // Fokus-Kontur nur nach Tab-Navigation (CSS: .revendo-quality-badge--pointer).
  // Escape schliesst das Popup und gibt den Fokus zurueck – das zaehlt nicht.
  document.addEventListener('pointerdown', function (event) {
    if (badge && badge.contains(event.target)) badge.classList.add('revendo-quality-badge--pointer');
  });
  document.addEventListener('keydown', function (event) {
    if (badge && event.key === 'Tab') badge.classList.remove('revendo-quality-badge--pointer');
  });

  placeQualityBadge();
  document.addEventListener('product-info:loaded', placeQualityBadge);
  document.addEventListener('shopify:section:load', placeQualityBadge);
  document.addEventListener('shopify:section:unload', function (event) {
    if (!badge || badge.dataset.revendoGalleryBadge !== event.detail.sectionId) return;
    badge.remove();
    badge = null;
  });
})();
// END Revendo: PDP Qualitaets-Badge
